import React from 'react';
import { ReactComponent as LinkedIn } from 'icons/linkedin.svg';
import { ReactComponent as Facebook } from 'icons/facebook.svg';
import { ReactComponent as Instagram } from 'icons/instagram.svg';
import { BUSINESS_ROUTE, CONTACT_US_ROUTE, PORTFOLIO_ROUTE } from 'data/global';

export type FooterLinks = {
  label: string;
  href: string;
  icon?: React.ReactNode;
};

export const homeLinks: FooterLinks[] = [
  {
    label: 'portfolio',
    href: PORTFOLIO_ROUTE,
  },
  {
    label: 'businesses',
    href: BUSINESS_ROUTE,
  },
];

export const evergreenLinks: FooterLinks[] = [
  {
    label: 'termsAndConditions',
    href: '/terms-and-conditions',
  },
  {
    label: 'privacyPolicy',
    href: '/privacy-policy',
  },
];

export const followUsLinks: FooterLinks[] = [
  {
    label: 'linkedin',
    href: 'https://www.linkedin.com/company/resolveaustralia',
    icon: LinkedIn,
  },
  {
    label: 'instagram',
    href: 'https://www.instagram.com/resolve_m.a',
    icon: Instagram,
  },
  {
    label: 'facebook',
    href: 'https://www.facebook.com/ResolveAU',
    icon: Facebook,
  },
];

export const contactUsLinks: FooterLinks[] = [
  {
    label: 'contactUs',
    href: CONTACT_US_ROUTE,
  },
];

export const footerLinks = {
  homeLinks: {
    title: 'homeSectionHeading',
    links: homeLinks,
  },
  evergreenLinks: {
    title: 'evergreen',
    links: evergreenLinks,
  },
  followUsLinks: {
    title: 'followUs',
    links: followUsLinks,
  },
  contactUsLinks: {
    title: 'contactUs',
    links: contactUsLinks,
  },
};
